import axios from "axios";
import { stage_url } from "../api-urls";
import Headers from "./Headers";

export const getInventoryFilter = async (payload) => {
  return await axios.get(`${stage_url}inventory/filter`, {
    headers: Headers.getHeaders(true),
    params: payload,
  });
};

export const getInventoryById = async (payload) => {
  return await axios.get(`${stage_url}inventory/${payload.id}`, {
    headers: Headers.getHeaders(true),
  });
};

export const editInventory = async (payload) => {
  return await axios.put(`${stage_url}inventory/${payload.id}`, payload, {
    headers: Headers.getHeaders(true),
  });
};

export const UpdateInventoryStatus = async (payload) => {
  return await axios.put(`${stage_url}inventory/${payload.id}/status`, null, {
    headers: Headers.getHeaders(true),
    params: {
      status: payload.status, 
    },
  });
};

export const addInventory = async (payload) => {
    return await axios.post(`${stage_url}inventory`, payload, {
        headers: Headers.getHeaders(true)
    })
}
